import { DesignToken } from '@microsoft/fast-foundation';
import { backgroundSwatch, foregroundSwatch } from './colors';
const { create } = DesignToken;
/**
 * The design tokens for the ag-theme-material theme.
 * @deprecated - use no usage in the codebase
 * @internal
 */
export const agThemeMaterialCustomTokens = {
    foregroundColor: create('fui-ag-foreground-color').withDefault(foregroundSwatch),
    backgroundColor: create('fui-ag-background-color').withDefault(backgroundSwatch),
};
